/* eslint-disable no-plusplus */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable consistent-return */
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import _ from "underscore";
import DeliveryPickUpWidget from "../../../components/DeliveryPickUpWidget/DeliveryPickUpWidget";
import Loader from "../../../components/Loader/Loader";
import BrandRefreshButtonSpinner from "../../../components/BrandRefreshButtonSpinner/BrandRefreshButtonSpinner";
import * as elementActions from "../../../redux/actions/elements";
import * as userActions from "../../../redux/actions/user";

import { defaultCurrency } from "../../../shared/constants/currency";
import { orderMethods, orderTypeIds } from "../../../shared/constants/order";
import { shippingMethods, storeIds } from "../../../shared/constants/store";

import * as orderRepo from "../../../shared/repos/graphql/order";

import * as productRepo from "../../../shared/repos/graphql/product";
import * as storeRepo from "../../../shared/repos/graphql/store";

import CheckoutCartButton from "../../../components/CheckoutCartButton/CheckoutCartButton";
import DiscountTag from "../../../components/DiscountTag/DiscountTag";
import GiftToggle from "../../../components/GiftToggle/GiftToggle";
import ProductOptions from "../../../components/ProductOptions/ProductOptions";
import QuickCheckoutButton from "../../../components/QuickCheckoutButton/QuickCheckoutButton";

import * as tagmanagerEvents from "../../../shared/utilities/tagmanagerEvents";

import endpoints from "../../../shared/constants/endpoints";
import errorCodes from "../../../shared/constants/errorCodes";
import { historyAction } from "../../../shared/constants/history";
import * as productConstants from "../../../shared/constants/product";
import styles from "./BoxProduct.module.css";
import { requestProductFulfillment } from "../../../shared/utilities/productFulfillment";

import Button from "../../../components/Button/Button";
import modalStyles from "../../../components/Modal/Modal.module.css";
import SimpleModal from "../../../components/Modal/SimpleModal";
import ExitIconSVG from "../../../components/Modal/imgs/exit-icon.svg";
import * as loyaltyAction from "../../../redux/actions/loyalty";
import { store } from "../../../redux/store";
import { PUNCHH_TYPE } from "../../../shared/constants/loyaltyType";
import {
  getErrorMessages,
  getErrorReasons,
  routeCountryPath
} from "../../../shared/utilities/common";
import { isBrandRefreshEnabled } from "../../../shared/utilities/brandRefresh";
import { calculateLoyaltyPoints } from "../../../shared/utilities/loyalty";
import { openOrderUpdateFailModal } from "../../../shared/utilities/modals";
import amplitudeAnalytics, {
  AMPLITUDE_NAV_SECTION_SECONDARY,
  formatAmplitudeSuggestedItemCategory,
  getAmplitudeSuggestedItemPageNameForPdp,
} from "../../../shared/utilities/amplitude";
import filterOutOrderProductOptions from "../../../shared/utilities/orderProductOptions";
import {
  clearCart,
  isDeliveryOrPickup
} from "../../../shared/utilities/orders";
import {
  handleProductWithDirectLink,
  sortOptionByPreset
} from "../../../shared/utilities/product";
import {
  reconcileProductSelections,
  getSelectedOptions,
  renderLoyaltyPrice
} from "../../../shared/utilities/renderings";
import {
  hasAvailableSleeveOptions,
  isBoxProduct
} from "../../../shared/utilities/sleeves";
import { getBoxSelectionProgress } from "../../../shared/utilities/pdpSelectionProgress";
import PresetBoxes from "../PresetBoxes/PresetBoxes";
import PdpStickySelectionHeader from "../PdpStickySelectionHeader/PdpStickySelectionHeader";
import { getCartErrorMessage } from "../../../shared/utilities/cart";
import brStyles from "./BoxProductBrandRefresh.module.css";

const backIcon = require("./imgs/back-icon.svg");
const lightBackIcon = require("./imgs/light-back-icon.svg");
const brBackIcon = require("./images/back-chevron-brand-refresh.svg");
const brCaretDown = require("./images/caret-down.svg");

class BoxProduct extends Component {
  constructor(props) {
    super(props);
    const { history } = this.props;
    this.state = {
      productOptionElement: {},
      pickAssortmentLoading: false,
      boxProducts: {},
      showQuantitySelector: false,
      productPrice: 0.0,
      customizeProducts: null,
      unavailableProducts: null,
      quantity: null,
      updateCartLoading: false,
      updatePriceLoading: false,
      productAddError: "",
      locationKey: history.location.key,
      points: 0,
      presetSelectionId: 0,
      isGift: false
    };

    this.handleOptionChange = this.handleOptionChange.bind(this);
    this.productTitleRef = React.createRef();
    this.actionsRef = React.createRef();
    this.qtyDropdownRef = React.createRef();
    this.actionsStickyBound = false;
    this.actionsStickyRaf = null;
  }

  async componentDidMount() {
    await this.initializeBoxProducts();
    await this.setProductData();
    handleProductWithDirectLink(this);
    if (isBrandRefreshEnabled()) {
      this.bindBrandRefreshActionsStickyRelease();
      this.syncBrandRefreshHeaderClearance();
    }
  }

  async componentDidUpdate(prevProps, prevState = {}) {
    const { selectedStore, history, location } = this.props;
    const { locationKey, showQuantitySelector } = this.state;
    const { showQuantitySelector: prevShowQuantitySelector } = prevState;
    if (prevProps !== this.props) {
      await this.initializeBoxProducts();
    }

    if (selectedStore && selectedStore !== prevProps.selectedStore) {
      await this.setProductData();
    }
    if (history.action === historyAction.pop && location.key !== locationKey) {
      history.goBack();
    }
    if (isBrandRefreshEnabled()) {
      this.bindBrandRefreshActionsStickyRelease();
      this.syncBrandRefreshActionsStickyRelease();
      this.syncBrandRefreshHeaderClearance();
    } else {
      this.unbindBrandRefreshActionsStickyRelease();
      this.teardownBrandRefreshHeaderClearance();
    }
    if (showQuantitySelector && !prevShowQuantitySelector) {
      this.scrollBrandRefreshQtyDropdownToSelected();
    }
  }

  componentWillUnmount() {
    this.unbindBrandRefreshActionsStickyRelease();
    this.teardownBrandRefreshHeaderClearance();
  }

  /**
   * Keep the selected qty near the bottom of the open list (e.g. "2" above
   * "1") instead of leaving scrollTop at 0 with "20" at the top.
   */
  scrollBrandRefreshQtyDropdownToSelected = () => {
    window.requestAnimationFrame(() => {
      const dropdown = this.qtyDropdownRef.current;
      if (!dropdown) {
        return;
      }
      const selected = dropdown.querySelector(
        '[data-part="qty-option"][data-selected="true"]'
      );
      if (!selected) {
        return;
      }
      dropdown.scrollTop = Math.max(
        0,
        selected.offsetTop + selected.offsetHeight - dropdown.clientHeight
      );
    });
  };

  /**
   * Desktop sticky CTA: hide the fade gradient only when the bar has
   * released with the info card (end of product section / footer in view).
   */
  syncBrandRefreshActionsStickyRelease = () => {
    if (this.actionsStickyRaf) {
      return;
    }
    this.actionsStickyRaf = window.requestAnimationFrame(() => {
      this.actionsStickyRaf = null;
      const el = this.actionsRef.current;
      if (!el) {
        return;
      }
      if (!window.matchMedia("(min-width: 992px)").matches) {
        if (el.getAttribute("data-released")) {
          el.removeAttribute("data-released");
        }
        return;
      }
      const parent = el.closest("[data-part='info-card']");
      if (!parent) {
        return;
      }
      const released =
        parent.getBoundingClientRect().bottom <= window.innerHeight + 1;
      const isReleased = el.getAttribute("data-released") === "true";
      if (released && !isReleased) {
        el.setAttribute("data-released", "true");
      } else if (!released && isReleased) {
        el.removeAttribute("data-released");
      }
    });
  };

  bindBrandRefreshActionsStickyRelease = () => {
    if (this.actionsStickyBound) {
      return;
    }
    this.actionsStickyBound = true;
    window.addEventListener(
      "scroll",
      this.syncBrandRefreshActionsStickyRelease,
      { passive: true }
    );
    window.addEventListener(
      "resize",
      this.syncBrandRefreshActionsStickyRelease
    );
    this.syncBrandRefreshActionsStickyRelease();
  };

  unbindBrandRefreshActionsStickyRelease = () => {
    if (!this.actionsStickyBound) {
      return;
    }
    this.actionsStickyBound = false;
    window.removeEventListener(
      "scroll",
      this.syncBrandRefreshActionsStickyRelease
    );
    window.removeEventListener(
      "resize",
      this.syncBrandRefreshActionsStickyRelease
    );
    if (this.actionsStickyRaf) {
      window.cancelAnimationFrame(this.actionsStickyRaf);
      this.actionsStickyRaf = null;
    }
    const el = this.actionsRef.current;
    if (el && el.getAttribute("data-released")) {
      el.removeAttribute("data-released");
    }
  };

  /**
   * Body already has padding for part of the fixed header; add the remaining
   * shortfall so photo/info cards clear the sticky nav with breathing room.
   */
  syncBrandRefreshHeaderClearance = () => {
    if (!isBrandRefreshEnabled()) {
      return;
    }

    const getHeaderEl = () =>
      document.querySelector('header[role="banner"]') ||
      document.querySelector('[role="banner"]') ||
      document.querySelector('[class*="headerWrapper"]') ||
      document.querySelector("header");

    const applyClearance = () => {
      const wrapper = document.querySelector('[data-region="box-product-pdp"]');
      const header = getHeaderEl();
      if (!wrapper) {
        return;
      }
      if (!header) {
        wrapper.style.setProperty("--bp-header-clearance", "0px");
        return;
      }
      const headerBottom = header.getBoundingClientRect().bottom;
      const bodyPad =
        parseFloat(window.getComputedStyle(document.body).paddingTop) || 0;
      const shortfall = Math.max(0, Math.round(headerBottom - bodyPad));
      wrapper.style.setProperty("--bp-header-clearance", `${shortfall}px`);
    };

    applyClearance();

    if (
      typeof ResizeObserver !== "undefined" &&
      !this.brandRefreshHeaderObserver
    ) {
      const header = getHeaderEl();
      if (header) {
        this.brandRefreshHeaderObserver = new ResizeObserver(applyClearance);
        this.brandRefreshHeaderObserver.observe(header);
      }
    }
  };

  teardownBrandRefreshHeaderClearance = () => {
    if (this.brandRefreshHeaderObserver) {
      this.brandRefreshHeaderObserver.disconnect();
      this.brandRefreshHeaderObserver = null;
    }
  };

  handleBackToMenu = () => {
    const { history, location, selectedStore } = this.props;
    const isShippingStore =
      selectedStore && selectedStore.id === storeIds.shipping;

    amplitudeAnalytics.trackClickNavSecondary({
      navElement: "Back to Menu",
      navSection: AMPLITUDE_NAV_SECTION_SECONDARY.PRODUCT_PAGE,
      pathname: location?.pathname,
    });
    history.push(
      routeCountryPath(
        isShippingStore
          ? endpoints.shippingPage
          : endpoints.getMenuUrl(selectedStore)
      )
    );
  };

  initializeBoxProducts = async () => {
    const { products, selectedStore } = this.props;

    const storeId = selectedStore ? selectedStore.id : storeIds.sampleMenu;

    if (!products) {
      await storeRepo.getStoreMenu(storeId).catch(() => {});
    }
  };

  setProductData = async () => {
    const {
      match,
      userCart,
      loyalty,
      redeemables,
      isShowOosProducts,
      productId
    } = this.props;
    const { params } = match;
    const { poid } = params;
    const selectedItem = userCart?.find(item => item.id === poid);
    const { customizeProducts, quantity } = this.state;
    let selectedOptions = customizeProducts;
    this.setState({
      updatePriceLoading: true,
      updateCartLoading: true,
      item: selectedItem
    });

    const id = productId ?? params.id;

    const redeemableId = redeemables?.redeemableId
      ? redeemables?.redeemableId
      : null;
    const { data } = await productRepo.getProduct(
      id,
      redeemableId,
      isShowOosProducts
    );
    const { product } = data;

    this.setState(prevState => ({
      product,
      productPrice: product.price,
      updatePriceLoading: false,
      updateCartLoading: false,
      // Set isGift from selectedItem if editing, otherwise keep current value
      isGift: selectedItem?.isGift ?? prevState.isGift
    }));
    if (!selectedOptions) {
      selectedOptions = getSelectedOptions(product, selectedItem);
    }
    if (!quantity) {
      this.setState({
        quantity: selectedItem ? selectedItem.quantity : 1
      });
    }
    const hadExistingSelections =
      customizeProducts && !_.isEmpty(customizeProducts);
    const reconciled = reconcileProductSelections(product, selectedOptions, {
      autoFill: !hadExistingSelections
    });

    this.setState({
      customizeProducts: reconciled.customizeProducts,
      boxProducts: reconciled.boxProducts,
      unavailableProducts: reconciled.unavailableProducts
    });

    if (loyalty) {
      this.getProductLoyaltyPoints(loyalty, id, poid);
    }
  };

  getProductLoyaltyPoints = (loyalty, id, poid) => {
    const {
      order,
      loyaltyPoints,
      loyaltyDeals,
      loyaltyRedeemables,
      history
    } = this.props;
    const loyaltyProducts =
      loyalty === PUNCHH_TYPE.REDEEMABLE ? loyaltyRedeemables : loyaltyDeals;
    try {
      const points = calculateLoyaltyPoints(
        loyalty,
        id,
        poid,
        loyaltyPoints,
        loyaltyProducts,
        order
      );
      this.setState({
        points
      });
    } catch (error) {
      history.push(endpoints.loyalty);
    }
  };

  setElement = element => {
    this.setState({
      productOptionElement: element // eslint-disable-line
    });
  };

  /**
   * Renders header section UI
   */
  renderCustomizeHeader = (
    title,
    actionLabel,
    action,
    buttonLabel,
    buttonAction
  ) => {
    const { pickAssortmentLoading } = this.state;

    return (
      <div className={styles.boxSectionHeader}>
        <div>
          <span className=" text-dark dark:text-white font-montserratMedium text-lg leading-[22px] tracking-[-0.1px] ">
            {title}
          </span>
          {actionLabel ? (
            <span
              onClick={action}
              className="text-[#983992] font-montserratBold text-lg leading-[22px] tracking-[-0.1px]"
            >
              {actionLabel}
            </span>
          ) : null}
        </div>

        {buttonLabel ? (
          <button
            data-ddog-id="pick_for_me"
            onClick={buttonAction}
            tabIndex={0}
            onKeyDown={e => e.key === "Enter" && buttonAction()}
            type="button"
            className={`${styles.headerButton} bg-dark dark:bg-button text-white font-montserratBold leading-[22px] tracking-[-0.1px] z-50`}
          >
            {pickAssortmentLoading ? (
              <Loader height={25} />
            ) : (
              <span>Pick for me</span>
            )}
          </button>
        ) : null}
      </div>
    );
  };

  pickAssortment = async () => {
    const { product, productOptionElement } = this.state;
    const { selectedStore } = this.props;

    const storeId = selectedStore ? selectedStore.id : storeIds.sampleMenu;
    const groupIds = _.pluck(product.options, "groupId");

    this.setState({
      pickAssortmentLoading: true
    });

    const response = await productRepo.getProductAssortment(
      product.id,
      groupIds,
      storeId
    );
    const { productAssortment } = response.data;

    const selections = {};

    productAssortment.forEach(optionGroup => {
      selections[optionGroup.id] = [];

      optionGroup.options.forEach(option => {
        for (let i = 1; i <= option.quantity; i++) {
          selections[optionGroup.id].push(option.productId);
        }
      });
    });

    const { boxProducts, customizeProducts } = reconcileProductSelections(
      product,
      selections
    );

    window.scrollTo({
      top: productOptionElement.current?.offsetTop || 0,
      left: 0
    });

    await this.setState({
      pickAssortmentLoading: false,
      boxProducts,
      customizeProducts
    });
  };

  onSelect = preset => {
    const { product } = this.state;

    this.setState({
      pickAssortmentLoading: true
    });

    const selections = {};
    const titles = {};

    preset.optionGroups.forEach(optionGroup => {
      selections[optionGroup.id] = [];

      optionGroup.options.forEach(option => {
        const optionId = option.productId.toString();
        titles[optionId] = option.productTitle;

        for (let i = 1; i <= option.quantity; i++) {
          selections[optionGroup.id].push(optionId);
        }
      });
    });

    const autoFill = !preset.isLastOrdered;
    const reconciled = reconcileProductSelections(product, selections, {
      autoFill,
      titles
    });

    product.options = sortOptionByPreset(
      product.options,
      reconciled.customizeProducts
    );
    product.productImage = preset.image;

    this.setState({
      pickAssortmentLoading: false,
      boxProducts: reconciled.boxProducts,
      customizeProducts: reconciled.customizeProducts,
      presetSelectionId: +preset.id,
      unavailableProducts: reconciled.unavailableProducts,
      showPersonalizedPresetUnavailableOptionsModal:
        !autoFill && reconciled.unavailableProducts.length > 0
    });
  };

  /**
   * Handles Option Modification
   * @param {array} options
   */
  handleOptionChange = options => {
    const { product } = this.state;
    const { boxProducts, customizeProducts } = reconcileProductSelections(
      product,
      options,
      { autoFill: false }
    );

    this.setState({
      boxProducts,
      customizeProducts
    });
  };

  /**
   * Adds Product to Shipping Order
   */
  addForShipping = async () => {
    this.setState({
      updateCartLoading: true
    });

    const { userCartId, setUserCartId } = this.props;
    const { boxProducts } = this.state;
    const boxProductsArray = [];

    Object.entries(boxProducts).forEach(box =>
      box[1].forEach(() => boxProductsArray.push(box[0]))
    );

    if (userCartId) {
      return this.handleAddProductToCart(userCartId);
    }

    const data = {
      orderTypeId: orderTypeIds.shipping,
      shippingMethod: shippingMethods.shipping,
      storeId: storeIds.shipping
    };

    try {
      const response = await orderRepo.createCart(data);

      const { createCart } = response.data;

      setUserCartId(createCart.code);

      return this.handleAddProductToCart(createCart.code);
    } catch (reason) {
      this.handleCartCreateError(reason);
    }
  };

  setCartStates = () => {
    const { history } = this.props;

    clearCart();
    history.push(routeCountryPath(endpoints.getMenuUrl(null)));
  };

  handleCartCreateError = reason => {
    const { setModalObject } = this.props;
    const message = getErrorMessages(reason, 0);
    const reasonType = getErrorReasons(reason, 0);
    const createReason = reasonType === errorCodes.CART_CREATE_ERROR;
    if (createReason) {
      setModalObject(openOrderUpdateFailModal(message, this.setCartStates));
    }
  };

  handleAddProductToCart = async (orderCode, quickCheckout = false, fulfillment) => {
    const {
      history,
      setUserCart,
      userOrderMethod,
      loyalty,
      loyaltyPoints,
      redeemables,
      order: currentOrder,
      userCart: existingCartItems,
      location,
      currency,
    } = this.props;
    const {
      product,
      quantity,
      customizeProducts,
      points,
      presetSelectionId,
      isGift
    } = this.state;

    const boxProductsArray = [];
    Object.entries(customizeProducts).forEach(([key, value]) => {
      boxProductsArray.push({
        productIds: value,
        groupOptionId: key
      });
    });

    const data = {
      product: product.id,
      quantity,
      productOptions: boxProductsArray,
      redeemableId:
        loyalty === PUNCHH_TYPE.REDEEMABLE ? redeemables?.redeemableId : null,
      dealId: loyalty === PUNCHH_TYPE.DEALS ? redeemables?.redeemableId : null,
      presetSelectionId,
      isGift: Boolean(isGift)
    };
    
    // Capture current orderProductIds so we can identify the newly created one later
    const existingOrderProductIds = new Set();
    (currentOrder?.items ?? []).forEach(item =>
      existingOrderProductIds.add(String(item.id))
    );
    (existingCartItems ?? []).forEach(item =>
      existingOrderProductIds.add(String(item.id))
    );

    let result;

    if (quickCheckout) {
      tagmanagerEvents.clickQuickCheckout({
        ...product,
        quantity,
        price: (product.price * quantity).toFixed(2)
      });
    } else {
      tagmanagerEvents.addToCart({
        ...product,
        quantity,
        price: (product.price * quantity).toFixed(2)
      });
    }

    try {
      result = await orderRepo.addProductToOrder(orderCode, data, {
        pathname: location?.pathname,
        source: 'box_product',
        currencySymbol: currency?.symbol || '$',
      });
      if (loyalty) {
        store.dispatch(loyaltyAction.loyaltyPoints(loyaltyPoints - points));
      }
    } catch (e) {
      this.setState({
        updateCartLoading: false,
        productAddError: getCartErrorMessage(e)
      });

      return;
    }

    const updatedOrder = result.data.addProductToOrderV2;
    const localStorageCart = updatedOrder.items.map(item => item);
    setUserCart(localStorageCart);

    const cartSuggestedPage = getAmplitudeSuggestedItemPageNameForPdp(
      location?.pathname,
      location?.search
    );
    if (cartSuggestedPage) {
      amplitudeAnalytics.trackAddSuggestedItem({
        pageName: cartSuggestedPage,
        productCategory: formatAmplitudeSuggestedItemCategory(product.categories),
        productName: product.title,
        productId: product.id,
      });
    }

    if (quickCheckout) {
      return result;
    }

    // Check if gift toggle is enabled and redirect to sleeve selection
    if (isGift && hasAvailableSleeveOptions(product)) {
      const newlyAddedItem = updatedOrder.items.find(
        item => !existingOrderProductIds.has(String(item.id))
      );
      const selectedOrderProduct =
        newlyAddedItem ||
        updatedOrder.items.find(item => item.product?.id === product.id) ||
        updatedOrder.items[0];

      if (selectedOrderProduct?.id) {
        const orderProductId = selectedOrderProduct.id;

        // Include orderProductId in the URL for reliability; keep state for backward compatibility
        history.push(
          routeCountryPath(
            `/products/box/${product.id}/options/${orderProductId}`
          ),
          {
            orderProductId
          }
        );
        return;
      }
    }

    const addLink =
      (fulfillment || userOrderMethod) === orderMethods.shipping
        ? endpoints.shippingPage
        : endpoints.menu;
    history.push(routeCountryPath(addLink));
  };

  /**
   * Adds Product to Order For Pickup Or Delivery based on UserOrderMethod Passed In.
   * @param quickCheckout
   */
  addForPickupDelivery = (quickCheckout = false) => {
    this.setState({ updateCartLoading: true });
    const {
      userCartId,
      selectedStore,
      userOrderMethod,
      setUserCartId,
      userAddress
    } = this.props;
    const { boxProducts } = this.state;
    const boxProductsArray = [];
    Object.entries(boxProducts).forEach(box =>
      box[1].forEach(() => boxProductsArray.push(box[0]))
    );

    if (selectedStore) {
      if (!userCartId) {
        let shippingMethod;
        let orderTypeId;

        if (userOrderMethod === orderMethods.delivery) {
          shippingMethod = 4;
          orderTypeId = 2;
        } else if (userOrderMethod === orderMethods.pickup) {
          shippingMethod = 3;
          orderTypeId = 3;
        }

        let storeId = null;
        if (selectedStore && selectedStore.id) {
          storeId = selectedStore.id;
        }

        const address = _.pick(userAddress, [
          "address1",
          "city",
          "lat",
          "lng",
          "postcode",
          "state"
        ]);
        const data = { orderTypeId, shippingMethod, storeId, address };
        return orderRepo
          .createCart(data)
          .then(responseCreatCart => {
            setUserCartId(responseCreatCart.data.createCart.code);
            return this.handleAddProductToCart(
              responseCreatCart.data.createCart.code,
              quickCheckout
            );
          })
          .catch(reason => {
            this.handleCartCreateError(reason);
          });
      }

      return this.handleAddProductToCart(userCartId, quickCheckout);
    }
    this.setState({ updateCartLoading: false });
    return true;
  };

  handleProductUpdate = async () => {
    const {
      userCartId,
      history,
      setUserCart,
      loyalty,
      redeemables,
    } = this.props;
    const {
      item,
      product,
      quantity,
      customizeProducts,
      presetSelectionId,
      isGift
    } = this.state;

    const customizeProductsArray = [];
    Object.entries(customizeProducts).forEach(([key, value]) => {
      customizeProductsArray.push({
        productIds: value,
        groupOptionId: key
      });
    });

    if (product?.title != null && product?.id != null) {
      amplitudeAnalytics.trackUpdateItem({
        productName: product.title,
        productId: product.id,
      });
    }

    tagmanagerEvents.addToCart({
      ...product,
      quantity,
      price: (product.price * quantity).toFixed(2)
    });

    let updateRes;
    try {
      updateRes = await orderRepo.addUpdateOrderProduct(userCartId, {
        orderProductId: parseInt(item.id, 10),
        product: product.id,
        price: product.price,
        quantity,
        productOptions: customizeProductsArray,
        redeemableId:
          loyalty === PUNCHH_TYPE.REDEEMABLE ? redeemables?.redeemableId : null,
        dealId: loyalty === PUNCHH_TYPE.DEALS ? redeemables?.redeemableId : null,
        presetSelectionId,
        isGift
      });
    } catch (reason) {
      this.setState({
        updateCartLoading: false,
        productAddError: getCartErrorMessage(reason)
      });

      return;
    }

    const order = updateRes.data.updateProductOrder;
    const localStorageCart = order.items.map(item1 => item1);
    setUserCart(localStorageCart);

    history.push(routeCountryPath(`/checkout/view-order/`));
  };

  /**
   * Handles the onClick event for Product
   */
  handleSubmit = async () => {
    const { userOrderMethod, setModalObject, updateProduct } = this.props;
    const { product } = this.state;
    if (product.oos === 1) {
      return;
    }
    if (requestProductFulfillment(this, code =>
      this.handleAddProductToCart(code, false, orderMethods.shipping)
    )) return;
    if (updateProduct) {
      return this.handleProductUpdate();
    }

    if (userOrderMethod === orderMethods.shipping) {
      return this.addForShipping();
    }
    if (isDeliveryOrPickup(userOrderMethod)) {
      return this.addForPickupDelivery(false);
    }
    return setModalObject({
      fullscreenChildren: true,
      children: (
        <DeliveryPickUpWidget
          isModal
          productId={product?.id}
          analyticsPageSection="Product Image"
        />
      )
    });
  };

  handleBrandRefreshAddItem = () => {
    const { product } = this.state;
    if (product?.oos === 1) {
      return undefined;
    }
    return this.handleSubmit();
  };

  handleBackToMenu = () => {
    const { history, selectedStore, location } = this.props;
    const isShippingStore =
      selectedStore && selectedStore.id === storeIds.shipping;
    amplitudeAnalytics.trackClickNavSecondary({
      navElement: "Back to Menu",
      navSection: AMPLITUDE_NAV_SECTION_SECONDARY.PRODUCT_PAGE,
      pathname: location?.pathname
    });
    history.push(
      routeCountryPath(
        isShippingStore
          ? endpoints.shippingPage
          : endpoints.getMenuUrl(selectedStore)
      )
    );
  };

  getBoxProductViewModel = () => {
    const {
      selectedStore,
      updateProduct,
      currency,
      loyalty,
      isCaloriesActive
    } = this.props;
    const {
      product,
      customizeProducts,
      updateCartLoading,
      productAddError,
      productPrice,
      updatePriceLoading,
      points,
      quantity,
      isGift,
      pickAssortmentLoading
    } = this.state;

    if (!product) {
      return null;
    }

    const storeId = selectedStore ? selectedStore.id : storeIds.sampleMenu;
    const filteredForValidation = filterOutOrderProductOptions(product.options);
    const productCount = filteredForValidation.reduce(
      (total, option) => total + option.minOptions,
      0
    );
    const currencySymbol = (currency && currency.symbol) || "$";
    const addProductText = selectedStore
      ? productConstants.ADD_TO_ORDER_TEXT
      : productConstants.ADD_TO_ORDER_NO_ADDRESS_TEXT;
    const boxProductsCounts = this.countOptionalCost();
    const { flattenedBox, optionalCost } = boxProductsCounts;
    const qty = quantity || 1;
    const totalCost =
      selectedStore && !updatePriceLoading
        ? (Number(productPrice) + optionalCost) * qty
        : null;
    const formattedTotalCost =
      totalCost != null && !Number.isNaN(totalCost)
        ? totalCost.toFixed(2)
        : null;
    const header = product.metaHeading || product.title;
    const { description } = product;
    const btnDisabled =
      pickAssortmentLoading ||
      (filteredForValidation.length &&
        (productCount - flattenedBox.length > 0 || updateCartLoading));
    const cta = updateProduct
      ? productConstants.UPDATE_PRODUCT_TEXT
      : addProductText;
    const remaining = productCount - flattenedBox.length;
    const isIncomplete = filteredForValidation.length && remaining > 0;
    // Label stays action-only; cash/points render on the right (legacy CTA parity / Carlos).
    let ctaButtonText;
    if (product.oos === 1) {
      ctaButtonText = productConstants.OUT_OF_STOCK_TEXT;
    } else if (isIncomplete) {
      ctaButtonText = `Pick ${remaining} more`;
    } else {
      ctaButtonText = cta;
    }
    let ctaPriceText = null;
    if (product.oos !== 1) {
      if (loyalty) {
        ctaPriceText = `${points} pts`;
      } else if (formattedTotalCost != null) {
        ctaPriceText = `${currencySymbol}${formattedTotalCost}`;
      }
    }
    const productPriceItem =
      selectedStore && !updatePriceLoading
        ? parseFloat(productPrice).toFixed(2)
        : null;
    const calories =
      isCaloriesActive && product.calories !== null
        ? ` ${product.calories} kCal`
        : "";

    return {
      product,
      customizeProducts,
      updateCartLoading,
      productAddError: productAddError || "",
      points,
      quantity: quantity || 1,
      isGift,
      storeId,
      header,
      description,
      calories,
      btnDisabled: product.oos === 1 || btnDisabled,
      ctaButtonText,
      ctaPriceText,
      productPriceItem,
      totalCost: formattedTotalCost,
      showCashPrice: !loyalty,
      currencySymbol
    };
  };

  brandRefreshContainer = () => {
    const viewModel = this.getBoxProductViewModel();
    const {
      currency,
      loyalty,
      selectedPreset,
      isCaloriesActive,
      cakeTopperProductId,
      cakeTopperUrl,
      designId
    } = this.props;

    if (!viewModel) {
      return (
        <div className={brStyles.pageWrapper}>
          <div data-part="page-loader">
            <Loader />
          </div>
        </div>
      );
    }

    const {
      product,
      customizeProducts,
      updateCartLoading,
      productAddError,
      points,
      isGift,
      storeId,
      header,
      description,
      calories,
      btnDisabled,
      ctaButtonText,
      ctaPriceText,
      productPriceItem,
      showCashPrice,
      currencySymbol,
      quantity
    } = viewModel;

    const { showQuantitySelector } = this.state;
    const showCtaQuantity = !loyalty;
    const quantityValues = _.range(
      productConstants.PRODUCT_MAX_QUANTITY_SELECTION,
      0
    );

    const { flattenedBox } = this.countOptionalCost();
    const selectionProgress = getBoxSelectionProgress(
      product.options,
      flattenedBox
    );
    const showStickySelectionHeader = selectionProgress.requiredCount > 0;

    return (
      <div
        className={brStyles.pageWrapper}
        data-region="box-product-pdp"
      >
        {showStickySelectionHeader ? (
          <PdpStickySelectionHeader
            productName={header}
            selectedCount={selectionProgress.selectedCount}
            requiredCount={selectionProgress.requiredCount}
            onBack={this.handleBackToMenu}
            observeTargetRef={this.productTitleRef}
            observeKey={product.id}
          />
        ) : null}
        <div data-part="pdp-inner">
          <div data-part="photo-card">
            {cakeTopperProductId === product.id && designId ? (
              <img
                alt={`${product.title} custom cake topper design`}
                src={`${cakeTopperUrl}/${designId}`}
              />
            ) : (
              <img alt={`${product.title} product`} src={product.productImage} />
            )}
          </div>

          <div data-part="info-card">
            <button
              type="button"
              data-part="back-link"
              onClick={this.handleBackToMenu}
            >
              <img
                alt=""
                src={brBackIcon}
                data-part="back-icon"
                aria-hidden="true"
              />
              Back to Menu
            </button>

            <div data-part="product-details">
              {product.discountPercent > 0 ? (
                <DiscountTag
                  discountPercent={product.discountPercent}
                  isBrandRefresh
                />
              ) : null}
              <div data-part="title-row">
                <h1 data-part="product-title" ref={this.productTitleRef}>
                  {header}
                </h1>

                {loyalty ? (
                  <div data-part="price-row">
                    <span data-part="loyalty-points">
                      {points}
                      {" pts"}
                    </span>
                    {renderLoyaltyPrice(this)}
                  </div>
                ) : showCashPrice && productPriceItem ? (
                  <div data-part="price-row">
                    {product.strike_price ? (
                      <>
                        <span data-part="price-strike">
                          {currencySymbol}
                          {parseFloat(product.strike_price).toFixed(2)}
                        </span>
                        <span>
                          {currencySymbol}
                          {productPriceItem}
                        </span>
                      </>
                    ) : (
                      <span>
                        {currencySymbol}
                        {productPriceItem}
                      </span>
                    )}
                  </div>
                ) : null}
              </div>

              <div data-part="product-copy">
                <p data-part="product-description">
                  {description}
                  {calories}
                </p>
                {product.nutritionInfoLink ? (
                  <a
                    data-part="nutrition-link"
                    href={product.nutritionInfoLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Nutritional info
                  </a>
                ) : null}
              </div>

              {hasAvailableSleeveOptions(product) && isBoxProduct(product) ? (
                <GiftToggle
                  isGift={isGift}
                  onChange={value => this.setState({ isGift: value })}
                  isBrandRefresh
                />
              ) : null}

              <PresetBoxes
                productId={product.id}
                onSelect={this.onSelect}
                selectedPreset={selectedPreset}
                onClear={this.clearPresets}
                storeId={storeId}
                currency={currency}
                includePersonalizedPreset
                pdpProductId={product.id}
                pdpProductTitle={product.metaHeading || product.title}
                isBrandRefresh
              />

              <div data-part="options">
                <ProductOptions
                  options={filterOutOrderProductOptions(product.options)}
                  onOptionChange={this.handleOptionChange}
                  customizeProducts={customizeProducts}
                  setElement={this.setElement}
                  isCaloriesActive={isCaloriesActive}
                  currency={currency}
                  tags={product.metaTags}
                  pdpProductId={product.id}
                  pdpProductTitle={product.metaHeading || product.title}
                  isBrandRefresh
                />
              </div>

              {/* Figma 8070:44330 — Box/Pack PDP has no pack-level "How many?" qty row */}
            </div>

            <div data-part="actions" ref={this.actionsRef}>
              {/* Figma 10760:77687 / 10760:77732 — sticky PDP Button with qty dropdown */}
              <div
                data-part="add-btn"
                data-loading={updateCartLoading ? "true" : undefined}
                data-disabled={
                  btnDisabled || updateCartLoading ? "true" : "false"
                }
              >
                {showQuantitySelector && showCtaQuantity ? (
                  <div
                    data-part="qty-dropdown"
                    role="listbox"
                    ref={this.qtyDropdownRef}
                  >
                    {quantityValues.map(value => (
                      <button
                        type="button"
                        key={value.toString()}
                        data-part="qty-option"
                        data-selected={value === quantity ? "true" : "false"}
                        onClick={e => {
                          e.stopPropagation();
                          this.setState({
                            quantity: value,
                            showQuantitySelector: false
                          });
                        }}
                      >
                        {value}
                      </button>
                    ))}
                  </div>
                ) : null}
                {showCtaQuantity ? (
                  <button
                    type="button"
                    data-part="qty-trigger"
                    aria-label="Select quantity"
                    disabled={btnDisabled || updateCartLoading}
                    onClick={e => {
                      e.stopPropagation();
                      if (!(btnDisabled || updateCartLoading)) {
                        this.setState(prev => ({
                          showQuantitySelector: !prev.showQuantitySelector
                        }));
                      }
                    }}
                  >
                    <span data-part="qty-value">{quantity}</span>
                    <img src={brCaretDown} alt="" data-part="qty-caret" />
                  </button>
                ) : null}
                <button
                  type="button"
                  data-part="add-btn-main"
                  data-loading={updateCartLoading ? "true" : undefined}
                  aria-busy={updateCartLoading ? "true" : undefined}
                  disabled={btnDisabled || updateCartLoading}
                  onClick={() => this.handleBrandRefreshAddItem()}
                >
                  {updateCartLoading ? (
                    <BrandRefreshButtonSpinner />
                  ) : (
                    <>
                      <span data-part="add-btn-label">{ctaButtonText}</span>
                      {ctaPriceText ? (
                        <span data-part="add-btn-price">{ctaPriceText}</span>
                      ) : null}
                    </>
                  )}
                </button>
              </div>
              {productAddError.length ? (
                <p data-part="error-message">{productAddError}</p>
              ) : null}
            </div>
          </div>
        </div>
        {this.renderPersonalizedPresetUnavailableOptionsModal()}
      </div>
    );
  };

  handleQuickCheckout = async () => {
    const { userOrderMethod, userCart, userCartId } = this.props;
    const { product } = this.state;
    if (product.oos === 1) {
      return;
    }
    if (requestProductFulfillment(this, code =>
      this.handleAddProductToCart(code, false, orderMethods.shipping)
    )) return;
    this.setCartLoading(true);

    if (isDeliveryOrPickup(userOrderMethod)) {
      const orderProductIds = _.pluck(userCart, "id");
      if (orderProductIds.length) {
        await orderRepo.removeProducts(userCartId, orderProductIds);
      }

      const [res] = await Promise.all([this.addForPickupDelivery(true)]);

      const { addProductToOrderV2 } = res.data;
      return { addProductToOrderV2 };
    }
  };

  setCartLoading = value => {
    this.setState({ updateCartLoading: value });
  };

  countOptionalCost = () => {
    const { boxProducts } = this.state;
    let optionalCost = 0;
    let isModifierHasExtraCost = false;
    const flattenedBox = Object.keys(boxProducts || {}).reduce(
      (flattenedArray, prod) => {
        // check modifier has extra cost
        isModifierHasExtraCost =
          !boxProducts[prod][0].optional && boxProducts[prod][0].price > 0;
        if (isModifierHasExtraCost) {
          // Calculate extra cost
          optionalCost += boxProducts[prod][0].price * boxProducts[prod].length;
        } else if (boxProducts[prod][0].optional) {
          optionalCost += boxProducts[prod][0].price * boxProducts[prod].length;
          return flattenedArray;
        }
        return flattenedArray.concat(boxProducts[prod]);
      },
      []
    );

    return {
      optionalCost,
      flattenedBox
    };
  };

  clearPresets = async () => {
    await this.setProductData();
    this.setState({
      boxProducts: {},
      customizeProducts: {},
      presetSelectionId: 0
    });
  };

  closePersonalizedPresetUnavailableOptionsModal = () => {
    this.setState({ showPersonalizedPresetUnavailableOptionsModal: false });
  };

  /* eslint-disable react/jsx-one-expression-per-line */
  renderPersonalizedPresetUnavailableOptionsModal = () => {
    const {
      showPersonalizedPresetUnavailableOptionsModal,
      unavailableProducts
    } = this.state;
    const totalQuantityUnavailable = unavailableProducts?.reduce(
      (total, item) => total + item.quantity,
      0
    );

    return showPersonalizedPresetUnavailableOptionsModal ? (
      <SimpleModal>
        <div
          className={[modalStyles.simpleModalContainer, "dark:bg-dark"].join(
            " "
          )}
        >
          <div className={modalStyles.closeOnlyHeader}>
            <div className={modalStyles.closeWrapper}>
              <img
                className="dark:image-negative"
                onClick={this.closePersonalizedPresetUnavailableOptionsModal}
                src={ExitIconSVG}
                alt=""
              />
            </div>
          </div>
          <div>
            <div>
              Unfortunately, some of the your previous selections are
              unavailable:
            </div>
            <div className="mt-3">
              {unavailableProducts.map(item => (
                <div key={item.productId}>
                  {item.productTitle} ({item.quantity})
                </div>
              ))}
            </div>
            <div className="mt-3">
              Please make {totalQuantityUnavailable} more selection
              {totalQuantityUnavailable > 1 ? "s" : ""}.
            </div>
          </div>
        </div>
        <div className="dark:bg-dark">
          <Button
            customContainerStyles="my-4"
            label="Continue"
            handleSubmit={this.closePersonalizedPresetUnavailableOptionsModal}
          />
        </div>
      </SimpleModal>
    ) : null;
  };

  /**
   * Renders Component
   */
  boxProductContainer = () => {
    const {
      updateProduct,
      selectedStore,
      designId,
      cakeTopperProductId,
      cakeTopperUrl,
      history,
      isCaloriesActive,
      currency,
      loyalty,
      selectedPreset,
      useFullscreenCarousel,
    } = this.props;

    const {
      pickAssortmentLoading,
      product,
      quantity,
      customizeProducts,
      updateCartLoading,
      productAddError,
      productPrice,
      updatePriceLoading,
      points,
      isGift
    } = this.state;

    if (!product) {
      return (
        <div className={styles.pageLoaderWrapper}>
          <Loader />
        </div>
      );
    }

    const storeId = selectedStore ? selectedStore.id : storeIds.sampleMenu;

    const filteredForValidation = filterOutOrderProductOptions(product.options);
    const productCount = filteredForValidation.reduce(
      (total, option) => total + option.minOptions,
      0
    );
    const addProductText = selectedStore
      ? productConstants.ADD_TO_ORDER_TEXT
      : productConstants.ADD_TO_ORDER_NO_ADDRESS_TEXT;

    const boxProductsCounts = this.countOptionalCost();
    const { flattenedBox, optionalCost } = boxProductsCounts;
    const qty = quantity || 1;
    const totalCostRaw =
      selectedStore && !updatePriceLoading
        ? (Number(productPrice) + optionalCost) * qty
        : null;
    const totalCost =
      totalCostRaw != null && !Number.isNaN(totalCostRaw)
        ? totalCostRaw.toFixed(2)
        : null;
    const header = product.metaHeading || product.title;
    const { description } = product;
    const remaining = Math.max(0, productCount - flattenedBox.length);
    const btnDisabled =
      pickAssortmentLoading ||
      (filteredForValidation.length &&
        (remaining > 0 || updateCartLoading));
    const cta = updateProduct
      ? productConstants.UPDATE_PRODUCT_TEXT
      : addProductText;
    const btnLabel = remaining > 0 ? `Pick ${remaining} more` : cta;
    const productPriceItem =
      selectedStore && !updatePriceLoading
        ? parseFloat(productPrice).toFixed(2)
        : null;
    const calories =
      isCaloriesActive && product.calories !== null
        ? ` ${product.calories} kCal`
        : "";
    const outOfStockText = productConstants.OUT_OF_STOCK_TEXT;
    const selectionProgress = getBoxSelectionProgress(
      product.options,
      flattenedBox
    );
    const showStickySelectionHeader =
      isBrandRefreshEnabled() && selectionProgress.requiredCount > 0;

    return (
      <div
        className={`${styles.boxPageContainer} flex justify-between gap-8 px-4 md:px-0`}
      >
        {showStickySelectionHeader ? (
          <PdpStickySelectionHeader
            productName={header}
            selectedCount={selectionProgress.selectedCount}
            requiredCount={selectionProgress.requiredCount}
            onBack={this.handleBackToMenu}
            observeTargetRef={this.productTitleRef}
            observeKey={product.id}
          />
        ) : null}
        <div className={`lg:mt-20 ${styles.boxImageContainer}`}>
          {cakeTopperProductId === product.id && designId ? (
            <img
              alt={`${product.title} custom cake topper design`}
              src={`${cakeTopperUrl}/${designId}`}
            />
          ) : (
            <img alt={`${product.title} product`} src={product.productImage} />
          )}
        </div>
        <div className={`${styles.boxDetailsContainer} flex flex-col gap-4`}>
          <div
            className={`${styles.detailsHeader} flex flex-col gap-4 items-start `}
          >
            <div className={`${styles.backMenu}`}>
              <div
                className="w-full flex justify-center text-dark dark:text-white items-center font-montserratBold"
                onClick={this.handleBackToMenu}
              >
                <span>
                  <img
                    alt=""
                    src={backIcon}
                    className="block dark:hidden h-6"
                  />
                  <img
                    alt=""
                    src={lightBackIcon}
                    className="hidden dark:block h-6"
                  />
                </span>
                Back to Menu
              </div>
            </div>
            {loyalty ? (
              <span className=" text-dark dark:text-white font-montserratMedium text-lg leading-[22px] tracking-[-0.1px] ">
                {points}
                {" pts"}
                {renderLoyaltyPrice(this)}
              </span>
            ) : productPriceItem ? (
              <div className="flex items-center gap-2">
                {product.strike_price ? (
                  <span className="text-dark dark:text-white font-montserratMedium text-lg leading-[22px] tracking-[-0.1px] ">
                    {currency.symbol}
                    <strike>
                      {parseFloat(product.strike_price).toFixed(2)}
                    </strike>
                    {currency.symbol}
                    {productPriceItem}
                  </span>
                ) : (
                  <span className="text-dark dark:text-white font-montserratMedium text-lg leading-[22px] tracking-[-0.1px] ">
                    {currency.symbol}
                    {productPriceItem}
                  </span>
                )}
                <DiscountTag discountPercent={product.discountPercent} />
              </div>
            ) : null}
            <h1
              ref={this.productTitleRef}
              className="font-congenialRegular font-bold text-[44px] leading-[46px] tracking-[-1px] text-dark dark:text-white"
            >
              {header}
            </h1>
          </div>

          <p className="text-dark dark:text-white font-montserratMedium text-lg leading-[22px] tracking-[-0.1px] ">
            <span className="text-dark dark:text-white font-montserratMedium text-lg leading-[22px] tracking-[-0.1px] ">
              {description}
            </span>{" "}
            <span className="text-dark dark:text-white font-montserratMedium text-lg leading-[22px] tracking-[-0.1px] ">
              {calories}
            </span>
          </p>

          {product.nutritionInfoLink ? (
            <h2
              className={`${styles.nutritionalInfo} text-[#983992] font-montserratBold text-lg leading-[22px] tracking-[-0.1px]`}
            >
              <a
                href={product.nutritionInfoLink}
                target="blank"
                className="text-[#983992] font-montserratBold text-lg leading-[22px] tracking-[-0.1px]"
              >
                Nutritional info
              </a>
            </h2>
          ) : null}

          {/* Gift Toggle - only show if sleeve options are available and in stock */}
          {hasAvailableSleeveOptions(product) && isBoxProduct(product) && (
            <GiftToggle
              isGift={isGift}
              onChange={value => this.setState({ isGift: value })}
            />
          )}

          <PresetBoxes
            productId={product.id}
            onSelect={this.onSelect}
            selectedPreset={selectedPreset}
            onClear={this.clearPresets}
            storeId={storeId}
            currency={currency}
            includePersonalizedPreset
            pdpProductId={product.id}
            pdpProductTitle={product.metaHeading || product.title}
          />

          <ProductOptions
            options={filterOutOrderProductOptions(product.options)}
            onOptionChange={this.handleOptionChange}
            customizeProducts={customizeProducts}
            setElement={this.setElement}
            isCaloriesActive={isCaloriesActive}
            currency={currency}
            tags={product.metaTags}
            pdpProductId={product.id}
            pdpProductTitle={product.metaHeading || product.title}
          />

          <div className={styles.cartWrapper}>
            {updateCartLoading ? (
              <div className={styles.loaderWrapper}>
                <Loader />
              </div>
            ) : null}
            <CheckoutCartButton
              onClick={() => {
                this.handleSubmit();
              }}
              isDisabled={btnDisabled}
              label={product.oos === 1 ? outOfStockText : btnLabel}
              price={loyalty ? points : totalCost}
              onQuantityChange={value => this.setState({ quantity: value })}
              quantity={loyalty ? null : quantity}
              loyalty={loyalty}
              boldLabel={useFullscreenCarousel}
            />

            <QuickCheckoutButton
              addProductToCart={this.handleQuickCheckout}
              setCartLoading={this.setCartLoading}
              isDisabled={btnDisabled}
              product={product}
              history={history}
            />
            {productAddError.length ? (
              <p className={styles.errorMessage}>{productAddError}</p>
            ) : null}
          </div>
        </div>
        {this.renderPersonalizedPresetUnavailableOptionsModal()}
      </div>
    );
  };

  render() {
    if (isBrandRefreshEnabled()) {
      return <this.brandRefreshContainer />;
    }
    return <this.boxProductContainer />;
  }
}

BoxProduct.propTypes = {
  cakeTopperProductId: PropTypes.string,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  cakeTopperUrl: PropTypes.string,
  isCaloriesActive: PropTypes.bool,
  isShowOosProducts: PropTypes.bool,
  currency: PropTypes.objectOf(PropTypes.string),
  useFullscreenCarousel: PropTypes.bool
};

BoxProduct.defaultProps = {
  cakeTopperProductId:
    window.environment.REACT_APP_CUSTOM_CAKE_TOPPER_PRODUCT_ID,
  cakeTopperUrl: window.environment.REACT_APP_CUSTOM_CAKE_TOPPER_URL,
  isCaloriesActive: false,
  isShowOosProducts: false,
  currency: defaultCurrency,
  useFullscreenCarousel: isBrandRefreshEnabled()
};

export const mapDispatchToProps = dispatch => ({
  setUserCart: value => dispatch(userActions.setUserCart(value)),
  setUserCartId: value => dispatch(userActions.setUserCartId(value)),
  setModalObject: value => dispatch(elementActions.setModalObject(value)),
  setStoreId: value => dispatch(userActions.setSelectedStore(value)),
  setUserOrderMethodId: value =>
    dispatch(userActions.setUserOrderMethod(value)),
  setUserAddress: value => dispatch(userActions.setUserAddress(value))
});

export const mapStateToProps = state => {
  const {
    userCart,
    userOrderMethod,
    selectedStore,
    userCartId,
    userInfo,
    userToken,
    userAddress
  } = state.user;
  const { products } = state.elements;
  const { designId } = state.customCakeTopper;
  const { isCaloriesActive, isShowOosProducts } = state.product;
  const { currency } = state.currency;
  const {
    loyaltyRedeemables,
    loyaltyDeals,
    loyaltyPoints,
    redeemables
  } = state.loyalty;
  const { order } = state;
  return {
    userCart,
    userOrderMethod,
    selectedStore,
    userCartId,
    userInfo,
    products,
    designId,
    userToken,
    userAddress,
    isCaloriesActive,
    isShowOosProducts,
    currency,
    loyaltyRedeemables,
    loyaltyDeals,
    loyaltyPoints,
    order,
    redeemables
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BoxProduct)
);
